export default "__VITE_ASSET__1majYKuL__"